import QueryString from 'query-string';
import { toastr } from "react-redux-toastr";
import { VIEW_ENDPOINT } from "../../config/endpoints";
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from "../../config/rest";
import { isErrorResponse } from "../../utils/error-handlers";
import {
  CLEAR_VIEW,
  CLEAR_VIEWS,
  FLAG_GETTING_VIEWS,
  FLAG_VIEW_ACTIVITY,
  GET_VIEWS,
  GET_VIEW,
} from '../types/security/View';
import { push } from 'react-router-redux';
import { VIEW_PATH } from '../../config/paths';

const flagGettingViews = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_VIEWS,
    payload: flag,
  });

const flagViewActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_VIEW_ACTIVITY,
    payload: flag,
  });

const getView = async ({ id }) => async (dispatch) => {
  dispatch(flagViewActivity(true));
  try {
    const url = `${VIEW_ENDPOINT}/${id}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const view = await response.json();
    dispatch({
      type: GET_VIEW,
      payload: view,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagViewActivity(false));
  }
};

const clearView = () => (dispatch) => {
  dispatch({
    type: CLEAR_VIEW,
  });
};
const getViews = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingViews(true));
    const query = tableFilters;
    const url = `${VIEW_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_VIEWS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingViews(false));
  }
}

const clearViews = () => (dispatch) =>
  dispatch({
    type: CLEAR_VIEWS,
  });

const postView = (data) => async (dispatch) => {
  dispatch(flagViewActivity(true));
  try {
    const response = await fetch(VIEW_ENDPOINT, {
      ...DEFAULT_POST_CONFIG,
      method: 'POST',
      body: JSON.stringify(data),
    });
    await isErrorResponse(response, null, dispatch);
    await response.json();
    dispatch(push(VIEW_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagViewActivity(false));
  }
};

const deleteView =
  async ({ viewId }) =>
  async (dispatch) => {
    try {
      dispatch(flagViewActivity(true));
      const url = `${VIEW_ENDPOINT}/${viewId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      }).then((res) => res);
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(VIEW_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagViewActivity(false));
    }
  };

  const putView =
  async ( viewId, data) =>
  async (dispatch) => {
    try {
      dispatch(flagViewActivity(true));
      const payload = {
        id: viewId,
        ...data,
      };
      const url = `${VIEW_ENDPOINT}/${viewId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(VIEW_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagViewActivity(false));
    }
  };


export {
  clearViews,
  clearView,
  getView,
  getViews,
  postView,
  putView,
  deleteView,
};